import {
	categoriesList,
	categoryByID,
	categoryCreate,
	categoryDestroy,
	categoryUpdate,
	serviceByID,
	serviceCreate,
	serviceDestroy,
	serviceList,
	serviceUpdate,
} from '@/services/agency/services.service'

export default {
	namespaced: true,
	state: {
		// SERVICE CATEGORIES
		categoriesList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		category: {},

		// STATUS SERVICE CATEGORIES
		categoriesStatus: 'pending',
		categoriesSaveStatus: 'init',
		categoriesDeleteStatus: 'init',

		// STATUS SERVICE
		serviceList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		service: {},

		// STATUS SERVICE
		serviceStatus: 'pending',
		serviceSaveStatus: 'init',
		serviceDeleteStatus: 'init',
	},
	getters: {
		// SERVICE CATEGORIES
		getCategoriesList(state) {
			return state.categoriesList
		},
		getCategory(state) {
			return state.category
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE CATEGORIES
		getCategoriesDeleteStatus(state) {
			return state.categoriesDeleteStatus
		},
		getCategoriesSaveStatus(state) {
			return state.categoriesSaveStatus
		},
		getCategoriesStatus(state) {
			return state.categoriesStatus
		},

		// SERVICE service
		getserviceList(state) {
			return state.serviceList
		},
		getservice(state) {
			return state.service
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE service
		getserviceDeleteStatus(state) {
			return state.serviceDeleteStatus
		},
		getserviceSaveStatus(state) {
			return state.serviceSaveStatus
		},
		getserviceStatus(state) {
			return state.serviceStatus
		},
	},
	mutations: {
		// SERVICE CATEGORIES
		CATEGORIES_LIST(state, value) {
			state.categoriesList = value
		},
		SET_CATEGORY(state, value) {
			state.category = value
		},

		// STATUS SERVICE CATEGORIES
		CATEGORIES_STATUS(state, value) {
			state.categoriesStatus = value
		},
		CATEGORY_SAVE_STATUS(state, value) {
			state.categoriesSaveStatus = value
		},
		CATEGORY_DELETE_STATUS(state, value) {
			state.categoriesDeleteStatus = value
		},

		// SERVICE service
		service_LIST(state, value) {
			state.serviceList = value
		},
		SET_service(state, value) {
			state.service = value
		},

		// STATUS SERVICE service
		service_STATUS(state, value) {
			state.serviceStatus = value
		},
		service_SAVE_STATUS(state, value) {
			state.serviceSaveStatus = value
		},
		service_DELETE_STATUS(state, value) {
			state.serviceDeleteStatus = value
		},
	},
	actions: {
		// Service Categories
		async fetchCategoryList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('CATEGORIES_STATUS', 'pending')
			commit('CATEGORIES_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await categoriesList(params)
				commit('CATEGORIES_STATUS', 'init')
				commit('CATEGORIES_LIST', data)
				return data
			} catch (error) {
				commit('CATEGORIES_STATUS', 'init')
				throw error
			}
		},
		async fetchCategoryByID({ commit }, params) {
			commit('CATEGORIES_STATUS', 'pending')
			try {
				const { data } = await categoryByID(params)
				commit('CATEGORIES_STATUS', 'init')
				commit('SET_CATEGORY', data.data)
				return data
			} catch (error) {
				commit('CATEGORIES_STATUS', 'init')

				return error
			}
		},
		async saveNewCategory({ commit }, params) {
			commit('CATEGORY_SAVE_STATUS', 'pending')
			try {
				const { data } = await categoryCreate(params)
				commit('CATEGORY_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CATEGORY_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateCategory({ commit }, params) {
			commit('CATEGORY_SAVE_STATUS', 'pending')
			try {
				const { data } = await categoryUpdate(params)
				commit('CATEGORY_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CATEGORY_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteCategoryByID({ commit }, params) {
			commit('CATEGORY_DELETE_STATUS', 'pending')
			try {
				const { data } = await categoryDestroy(params)
				commit('CATEGORY_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CATEGORY_DELETE_STATUS', 'error')

				return error
			}
		},

		// Service service
		async fetchserviceList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('service_STATUS', 'pending')
			commit('service_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await serviceList(params)
				commit('service_STATUS', 'init')
				commit('service_LIST', data)
				return data
			} catch (error) {
				commit('service_STATUS', 'init')
				throw error
			}
		},
		async fetchserviceByID({ commit }, params) {
			commit('service_STATUS', 'pending')
			try {
				const { data } = await serviceByID(params)
				commit('service_STATUS', 'init')
				commit('SET_service', data.data)
				return data
			} catch (error) {
				commit('service_STATUS', 'init')

				return error
			}
		},
		async saveNewservice({ commit }, params) {
			commit('service_SAVE_STATUS', 'pending')
			try {
				const { data } = await serviceCreate(params)
				commit('service_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('service_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateservice({ commit }, params) {
			commit('service_SAVE_STATUS', 'pending')
			try {
				const { data } = await serviceUpdate(params)
				commit('service_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('service_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteserviceByID({ commit }, params) {
			commit('service_DELETE_STATUS', 'pending')
			try {
				const { data } = await serviceDestroy(params)
				commit('service_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('service_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
